import React, { useEffect, useState } from "react";
import {
  message,
  Select,
  Drawer,
  Tabs,
  // Button,
  DatePicker,
  Spin,
} from "antd";
import PropTypes from "prop-types";
// import { CloseOutlined } from "@ant-design/icons";
import { BASE_CRM_URL } from "../../../components/config/config";
import Swal from "sweetalert2";
import axios from "axios";
import dayjs from "dayjs";

const EditExpenses = ({ open, onClose, getExpenses, record, type }) => {
  const [formData, setFormData] = useState({
    reason: "",
    note: "",
    date: "",
    reference: "",
    amount: "",
    supplier: "",
  });

  useEffect(() => {
    if (record) {
      console.log(record, "recorddddddddddddd");
      setFormData({
        reason: record.expense_name || "",
        note: record.note || "",
        date: record.date ?? "",
        reference: record.reference_no || "",
        amount: record.amount || "",
        supplier: record.supplier || "",
      });
      setSelectedTax1(record.tax ?? null);

      // Preselect Tax 2
      setSelectedTax2(record.tax2 ?? null);

      // Preselect Group
      setSelectedcategory(record.category ?? null);
      setSelectedCustomer(record.clientid ?? null);
      setSelectedProject(record.project_id ?? null);
      setSelectedPayment(
        record.paymentmode !== null && record.paymentmode !== undefined
          ? Number(record.paymentmode)
          : null,
      );
    }
    // Existing expense receipt
    if (record?.file_id && record?.file_name && record?.external_link) {
      setFilePreview({
        id: record?.file_id,
        name: record?.file_name,
        type: record?.filetype || "",
        url: record?.external_link,
      });
    } else {
      setFilePreview(null);
    }

    // Existing file is NOT a new file
    setSelectedFile(null);
  }, [record]);

  const getDrawerWidth = () => {
    const width = window.innerWidth;

    if (width <= 576) {
      return "90%";
    }

    if (width <= 992) {
      return "60%";
    }

    if (width <= 1440) {
      return "45%";
    }

    return "20%";
  };

  const [loading, setLoading] = useState(false);

  const [taxOptions, setTaxOptions] = useState([]);
  const [taxLoading, setTaxLoading] = useState(false);
  const [selectedTax1, setSelectedTax1] = useState(null);
  const [selectedTax2, setSelectedTax2] = useState(null);

  const [expenseCatogryes, setExpenseCatogrys] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);
  const [selectedCategory, setSelectedcategory] = useState(null);

  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  const [projectOptions, setProjectOptions] = useState([]);
  const [projectLoading, setProjectLoading] = useState(false);
  const [selectedProject, setSelectedProject] = useState(null);

  const [paymentOptions, setPaymentOptions] = useState([]);
  const [paymentLoading, setPaymentLoading] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [activeTab, setActiveTab] = useState("basic");
  const [selectedFile, setSelectedFile] = useState(null);
  const [filePreview, setFilePreview] = useState(null);
  const isRelatedLocked = Boolean(type);
  const getTaxes = async () => {
    try {
      setTaxLoading(true);

      const response = await fetch(`${BASE_CRM_URL}GetTaxes`);

      const data = await response.json();

      if (data.Status) {
        const options = (data.ResultData || []).map((item) => ({
          value: item.Id,
          label: item.Name,
          taxrate: Number(item.taxrate || 0),
        }));

        setTaxOptions(options);
      } else {
        setTaxOptions([]);
      }
    } catch (error) {
      console.error("Error fetching taxes:", error);
      setTaxOptions([]);
    } finally {
      setTaxLoading(false);
    }
  };

  const getExpenseCatogery = async () => {
    setCategoryLoading(true);
    try {
      const response = await fetch(
        `${BASE_CRM_URL}expenses/GetExpenseCategories`,
      );
      const data = await response.json();
      if (data?.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setExpenseCatogrys(options);
      } else {
        setExpenseCatogrys([]);
      }
    } catch (error) {
      console.error("Error fetching categories", error);
    } finally {
      setCategoryLoading(false);
    }
  };

  const getCustomers = async () => {
    setCustomerLoading(true);
    try {
      const response = await fetch(`${BASE_CRM_URL}customers/GetCustomers`);
      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.customerId,
          label: item.company,
        }));

        setCustomerOptions(options);
      }
    } catch (error) {
      console.error("Error fetching related types:", error);
    } finally {
      setCustomerLoading(false);
    }
  };

  const getProjects = async (customerId) => {
    try {
      setProjectLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}project/GetProjectsByCusId?CusID=${customerId}`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setProjectOptions(options);
      } else {
        setProjectOptions([]);
      }
    } catch (error) {
      console.error("Error fetching projects:", error);
      setProjectOptions([]);
    } finally {
      setProjectLoading(false);
    }
  };

  const getPaymentMode = async () => {
    setPaymentLoading(true);
    try {
      const response = await fetch(`${BASE_CRM_URL}expenses/GetPaymentModes`);
      const data = await response.json();
      if (data?.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));
        setPaymentOptions(options);
      } else {
        setPaymentOptions([]);
      }
    } catch (error) {
      console.error("Error fetching categories", error);
    } finally {
      setPaymentLoading(false);
    }
  };

  useEffect(() => {
    getTaxes();
    getExpenseCatogery();
    getCustomers();
    getPaymentMode();
  }, []);

  useEffect(() => {
    if (selectedCustomer) {
      getProjects(selectedCustomer);
    }
  }, [selectedCustomer]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const isImageFile = (file) => {
    if (!file) return false;

    return (
      file.type?.startsWith("image/") ||
      /\.(jpg|jpeg|png|gif|webp|svg)$/i.test(file.name || "")
    );
  };

  const handleFileChange = (e) => {
    const file = e.target.files?.[0];

    if (!file) return;

    setSelectedFile(file);

    setFilePreview({
      name: file.name,
      type: file.type,
      url: URL.createObjectURL(file),
      isNew: true,
    });

    // Allow selecting the same file again
    e.target.value = "";
  };
  const basicContent = (
    <div>
      <div className="mb-3">
        <label className="form-label">Receipt / Attachment</label>

        <div
          className="border border-2 border-secondary border-dashed rounded text-center p-3"
          style={{ minHeight: "180px" }}
        >
          <input
            id="expenseFileInput"
            type="file"
            hidden
            onChange={handleFileChange}
          />

          {filePreview ? (
            <>
              {/* IMAGE PREVIEW */}
              {isImageFile(filePreview) ? (
                <img
                  src={filePreview.url}
                  alt={filePreview.name}
                  className="img-fluid rounded mb-2"
                  style={{
                    maxHeight: "180px",
                    maxWidth: "100%",
                    objectFit: "contain",
                  }}
                />
              ) : (
                /* NON-IMAGE FILE */
                <div className="mb-2">
                  <i className="fa-solid fa-file fa-3x text-secondary"></i>
                </div>
              )}

              {/* FILE NAME */}
              <div
                className="fw-semibold text-break mb-2"
                title={filePreview.name}
              >
                {filePreview.name}
              </div>

              {/* ACTION BUTTONS */}
              <div className="d-flex justify-content-center gap-2">
                {/* VIEW BUTTON - only for existing file */}
                {!filePreview.isNew && (
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={() =>
                      window.open(
                        filePreview.url,
                        "_blank",
                        "noopener,noreferrer",
                      )
                    }
                  >
                    <i className="fa-solid fa-eye me-1"></i>
                    View
                  </button>
                )}

                {/* CHANGE BUTTON */}
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  onClick={() =>
                    document.getElementById("expenseFileInput")?.click()
                  }
                >
                  <i className="fa-solid fa-pen me-1"></i>
                  Change
                </button>
              </div>

              {filePreview.isNew && (
                <div className="small text-success mt-2">
                  New file selected. Click Save to upload.
                </div>
              )}
            </>
          ) : (
            /* NO FILE */
            <div
              style={{ cursor: "pointer" }}
              onClick={() =>
                document.getElementById("expenseFileInput")?.click()
              }
            >
              <i className="fa-solid fa-cloud-arrow-up fa-3x text-secondary mb-3"></i>

              <h6>Upload Receipt</h6>

              <p className="text-muted mb-2">
                Click to browse or select a file
              </p>

              <button type="button" className="btn btn-primary btn-sm">
                <i className="fa-solid fa-upload me-1"></i>
                Choose File
              </button>
            </div>
          )}
        </div>
      </div>

      <div className="row pt-3">
        <div className="col-6 mb-3">
          <label className="form-label">Expense Category</label>

          <Select
            placeholder="Select Expense Category"
            style={{ width: "100%", height: 38 }}
            allowClear
            showSearch
            optionFilterProp="label"
            loading={categoryLoading}
            options={expenseCatogryes}
            value={selectedCategory}
            onChange={(value) => {
              setSelectedcategory(value);
            }}
          />
        </div>

        <div className="col-6 mb-3">
          <label className="form-label">Reason</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter expense reason"
            name="reason"
            value={formData.reason}
            onChange={handleInputChange}
          />
        </div>

        <div className="col-6 mb-3">
          <label className="form-label">Expense Date</label>

          <DatePicker
            format="DD-MM-YYYY"
            className="form-control"
            value={formData.date ? dayjs(formData.date) : null}
            onChange={(date) => {
              handleInputChange({
                target: {
                  name: "date",
                  value: date ? date.format("YYYY-MM-DD") : "",
                },
              });
            }}
          />
        </div>

        <div className="col-6 mb-3">
          <label className="form-label">Amount</label>

          <input
            type="number"
            className="form-control"
            placeholder="Enter amount"
            name="amount"
            value={formData.amount}
            onChange={handleInputChange}
            min="0"
            step="0.01"
          />
        </div>

        {/* Supplier */}

        <div className="col-6 mb-3">
          <label className="form-label">Supplier</label>

          <input
            type="text"
            className="form-control"
            placeholder="Enter supplier"
            name="supplier"
            value={formData.supplier}
            onChange={handleInputChange}
          />
        </div>
        <div className="col-6 mb-3">
          <label className="form-label">Customer</label>

          <Select
            placeholder="Select Customer"
            style={{ width: "100%", height: 38 }}
            allowClear
            showSearch
            optionFilterProp="label"
            loading={customerLoading}
            options={customerOptions}
            disabled={isRelatedLocked}
            value={selectedCustomer}
            onChange={(value) => {
              setSelectedCustomer(value);
              getProjects(value);
            }}
          />
        </div>

        {selectedCustomer && (
          <div className="col-6 mb-3">
            <label className="form-label">Project</label>

            <Select
              placeholder="Select Project"
              style={{ width: "100%", height: 38 }}
              allowClear
              showSearch
              optionFilterProp="label"
              loading={projectLoading}
              options={projectOptions}
              value={selectedProject}
              onChange={(value) => {
                setSelectedProject(value);
              }}
            />
          </div>
        )}

        {/* Note */}

        <div className="col-12 mb-3">
          <label className="form-label">Note</label>

          <textarea
            className="form-control"
            rows={3}
            placeholder="Enter note"
            name="note"
            value={formData.note}
            onChange={handleInputChange}
          />
        </div>
      </div>
    </div>
  );

  const advancedContent = (
    <div className="row">
      <div className="col-6 mb-3">
        <label className="form-label">Tax 1</label>

        <Select
          className="w-100"
          placeholder="Select Tax"
          loading={taxLoading}
          options={taxOptions}
          value={selectedTax1}
          onChange={(value) => {
            setSelectedTax1(value);
          }}
          style={{ height: 38 }}
          allowClear
        />
      </div>

      {/* Tax 2 */}

      <div className="col-6 mb-3">
        <label className="form-label">Tax 2</label>

        <Select
          className="w-100"
          placeholder="Select Tax"
          style={{ height: 38 }}
          options={taxOptions}
          loading={taxLoading}
          value={selectedTax2}
          onChange={(value) => {
            setSelectedTax2(value);
          }}
          allowClear
        />
      </div>

      {/* Payment Mode */}

      <div className="col-6 mb-3">
        <label className="form-label">Payment Mode</label>

        <Select
          placeholder="Select Payment Type"
          style={{ width: "100%", height: 38 }}
          allowClear
          showSearch
          optionFilterProp="label"
          options={paymentOptions}
          loading={paymentLoading}
          value={selectedPayment}
          onChange={(value) => {
            setSelectedPayment(value);
          }}
        />
      </div>

      {/* Reference */}

      <div className="col-6 mb-3">
        <label className="form-label">Reference #</label>

        <input
          type="text"
          className="form-control"
          placeholder="Enter reference number"
          name="reference"
          value={formData.reference}
          onChange={handleInputChange}
        />
      </div>
    </div>
  );

  const handleNext = () => {
    setActiveTab("advanced");
  };

  const handleReset = () => {
    setActiveTab("basic");

    onClose();
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);

      const payload = new FormData();

      payload.append("id", record.id);
      payload.append("category", selectedCategory ?? "");
      payload.append("currency", 5);
      payload.append("amount", formData.amount ? Number(formData.amount) : 0);
      payload.append("tax", selectedTax1 ?? "");
      payload.append("tax2", selectedTax2 ?? "");
      payload.append("note", formData.note || "");
      payload.append("expense_name", formData.reason || "");
      payload.append("clientid", selectedCustomer ?? 0);
      payload.append("project_id", selectedProject ?? 0);
      payload.append("paymentmode", selectedPayment ?? "");
      payload.append("date", formData.date || "");
      payload.append("reference", formData.reference || "");

      // Only send file when user clicked Change
      // and selected a new file.
      if (selectedFile) {
        payload.append("file", selectedFile);
      }

      // Debug
      for (const [key, value] of payload.entries()) {
        console.log(key, value);
      }

      const response = await axios.post(
        `${BASE_CRM_URL}expenses/UpdateExpense`,
        payload,
      );

      if (response.data?.Status) {
        // Refresh expenses list immediately after successful update
        await getExpenses();

        // Clear file state
        setSelectedFile(null);
        setFilePreview(null);

        // Reset tab
        setActiveTab("basic");

        // Close drawer
        onClose();

        // Show success message
        Swal.fire({
          title: "Success",
          text: response.data?.Message || "Expense updated successfully",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: response.data?.Message || "Failed to update expense",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } catch (error) {
      console.error("Update Expense Error:", error);

      message.error(
        error.response?.data?.Message || "Failed to update expense",
      );
    } finally {
      setLoading(false);
    }
  };
  return (
    <div>
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
            backgroundColor: "rgba(255, 255, 255, 0.2)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}

      <Drawer
        title="Edit Expense"
        placement="right"
        open={open}
        onClose={handleReset}
        width={getDrawerWidth()}
        destroyOnClose
        styles={{
          body: {
            paddingTop: 0,
          },
        }}
        closable={false}
        extra={
          <div className="d-flex justify-content-end gap-2">
            {/* <Button type="text" icon={<CloseOutlined />} onClick={onClose} /> */}

            <button
              type="button"
              onClick={handleReset}
              disabled={loading}
              className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
              style={{
                width: "35px",
                height: "35px",
                backgroundColor: "#e40d22",
                color: "#fff",
                border: "none",
              }}
              title="Close"
            >
              <i className="fa fa-times" />
            </button>

            {activeTab === "basic" ? (
              <button
                type="button"
                onClick={handleNext}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#f1f51e",
                  color: "#fff",
                  border: "none",
                }}
                title="Next"
              >
                <i className="fa fa-arrow-right" />
              </button>
            ) : (
              <button
                type="button"
                onClick={handleUpdate}
                disabled={loading}
                className="btn rounded-circle d-flex align-items-center justify-content-center shadow-sm"
                style={{
                  width: "35px",
                  height: "35px",
                  backgroundColor: "#07f083",
                  color: "#fff",
                  border: "none",
                }}
                title="Save"
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                ) : (
                  <i className="fa fa-check" />
                )}
              </button>
            )}
          </div>
        }
        // footer={
        //   <div className="d-flex justify-content-end">
        //     <Button className="me-2" onClick={onClose} disabled={loading}>
        //       Close
        //     </Button>

        //     <Button type="primary" loading={loading} onClick={handleUpdate}>
        //       Save
        //     </Button>
        //   </div>
        // }
      >
        <Tabs
          activeKey={activeTab}
          onChange={(key) => setActiveTab(key)}
          items={[
            {
              key: "basic",
              label: "Basic",
              children: basicContent,
            },
            {
              key: "advanced",
              label: "Advanced",
              children: advancedContent,
            },
          ]}
        />

        {/* <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-secondary me-2"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSave}
          >
            Save
          </button>
        </div> */}
      </Drawer>
    </div>
  );
};
EditExpenses.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  getExpenses: PropTypes.func.isRequired,
  record: PropTypes.object,
  type: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default EditExpenses;
